<template>
<div>
    <el-dialog title=" " :visible.sync="bluesheetsEnterKeyOpen"
    :modal-append-to-body="false" :show-close="false" class="bluesheets_box"
    :close-on-click-modal="false" width="840px" center>
      <h3>Please enter the key of the organization</h3>
      <el-input class="key-input" v-model="bluesheetsEnterKey" />
      <div class="foot_box">
        <el-button @click="cancelBluesheetsConfirm" class="cardCanBtn" style="margin-left: 0">Back</el-button>
        <el-button @click="confirmBluesheetsEnterKey" class="cardConBtn">Confirm<i v-if="bluesheetsConfirming" class="el-icon-loading"></i></el-button>
      </div>
    </el-dialog>

    <el-dialog title="Please select from the below options" :visible.sync="showBindBluesheetsAsk"
    :modal-append-to-body="false" :show-close="false" class="delsmsDio_box"
    :close-on-click-modal="false" width="1250px" center>
      <div class="foot_box">
        <el-button @click="cancelContinue" class="cardCanBtn" style="margin-left: 0">Cancel</el-button>
        <el-button @click="disBluesheets" class="cardCanBtn">Unlink</el-button>
        <el-button @click="openBluesheetsEnterKey" class="cardConBtn">Re-link</el-button>
      </div>
    </el-dialog>

    <el-dialog title=" " :visible.sync="alertMultiData"
    :modal-append-to-body="false" :show-close="true" class="bluesheets_box"
    :close-on-click-modal="false" width="840px" center>
      <h2>Do you have one venue in your<br />
        organisation?</h2>
      <div class="foot_box">
        <el-button @click="noOpereate" class="cardCanBtn" style="margin-left: 0">No<i v-if="abstaining" class="el-icon-loading"></i></el-button>
        <el-button @click="yesOperate" class="cardConBtn">Yes</el-button>
      </div>
    </el-dialog>

    <el-dialog title=" " :visible.sync="selectOrganisation"
    :modal-append-to-body="false" :show-close="false" class="bluesheets_box"
    :close-on-click-modal="false" width="840px" center>
      <div v-if="defaultData && defaultData.length > 0">
        <h2>We found the following categories under your account,<br />
            please tick the category data you want.</h2>
        <div class="tree-scroll">
            <el-tree
                class="tree"
                ref="tree"
                :data="defaultData"
                show-checkbox
                :default-expanded-keys="defaultExpanded"
                node-key="id"
                :empty-text="' '"
                @check-change="clickEvent">
            </el-tree>
        </div>
        <div class="foot_box">
            <el-button @click="cancelOpereate" class="cardCanBtn" style="margin-left: 0">Cancel<i v-if="abstaining" class="el-icon-loading"></i></el-button>
            <el-button @click="confirmOperate" :disabled='chosed.length === 0' class="cardConBtn">Confirm<i v-if="confirmingData" class="el-icon-loading"></i></el-button>
        </div>
      </div>
      <div v-else>
        <h2>No tracking category has been set for this account Continue</h2>
        <div class="foot_box">
            <el-button @click="selectOrganisation = false" class="cardConBtn lef0">Continue</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title=" " :visible.sync="showSuccess"
    :modal-append-to-body="false" :show-close="false" class="bluesheets_box"
    :close-on-click-modal="false" width="660px" center>
      <div class="success-icon"></div>
      <h2>Bluesheets account has been<br />successfully linked!</h2>
      <div class="foot_box">
        <el-button @click="done" class="cardConBtn lef0">Confirm</el-button>
      </div>
    </el-dialog>
</div>
</template>

<script>
import api from '../../api/api';

export default {
    name: 'bluesheets',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        showAsk: {
            type: Boolean,
            default: false
        },
    },
    data() {
		return {
            showBindBluesheetsAsk: false,

            bluesheetsEnterKey: '',
            bluesheetsEnterKeyOpen: false,
            bluesheetsConfirming: false,

            alertMultiData: false,
            

            selectOrganisation: false,
            defaultExpanded: [],
            defaultData: [],
            chosed: [],
            confirmingData: false,

            showSuccess: false,

            abstaining: false
		}
	},
    methods: {
        // 8848
        openBluesheetsEnterKey() {
            var that = this
            that.showBindBluesheetsAsk = false
            that.bluesheetsEnterKey = ''
            that.bluesheetsEnterKeyOpen = true
        },
        cancelBluesheetsConfirm() {
            var that = this
            if (that.bluesheetsConfirming)
                return
            that.bluesheetsEnterKeyOpen = false
            that.$emit('closeShow')
            that.$emit('closeShowAsk')
        },
        cancelContinue() {
            this.$emit('closeShowAsk')
            this.showBindBluesheetsAsk = false
        },
        disBluesheets(){
            var that = this
            that.showBindBluesheetsAsk = false;
            that.$emit('closeShowAsk')
            Utils.loadings();
            api.bluesheetDisConnectApi({ 
                callback: (res) => {
                    Utils.loadings(2);
                    if (!res || !res.data)
                        return
                    if (res.data.code === 0) {
                        that.$emit('unBind')
                    } else if (res.data.code == 8902) {
                        sessionStorage.clear()
                        that.$router.push('/login')
                    } else {
                        Utils.alert('', res.data.message, 'error')
                    }
                }
            });
        },
        confirmBluesheetsEnterKey() {
            var that = this
            if (that.bluesheetsConfirming)
                return
            if (that.bluesheetsEnterKey.replace(/\s+/g,'') === '')
                return
            that.bluesheetsConfirming = true
            that.defaultData = []
            that.defaultExpanded = []
            that.chosed = []
            // 开始请求
            api.bluesheetBindApi({
                params: {
                    code: that.bluesheetsEnterKey
                },
                callback: (res) => {
                    
                    that.cancelBluesheetsConfirm()
                    if (!res || !res.data)
                        return
                    if (res.data.code === 0) {
                        if (res.data.data.length > 1 || (res.data.data[0] && res.data.data[0].trackingOptionPOJOList.length > 1)){
                            that.bluesheetsConfirming = false
                            that.alertMultiData = true
                            that.bluesheetsEnterKeyOpen = false
                            that.$emit('closeShow')
                            that.$emit('closeShowAsk')
                        }
                        else {
                            that.autoConfirmOperate()
                        }
                            
                        res.data.data.forEach(item => {
                            let children = []
                            item.trackingOptionPOJOList.forEach(i => {
                                children.push({
                                    id: i.optionId,
                                    label: i.name,
                                    parent: item.categoryId 
                                })
                            })
                            that.defaultData.push({
                                id: item.categoryId,
                                label: item.name,
                                children: children
                            })
                            that.defaultExpanded.push(item.categoryId)
                        })
                    } else if (res.data.code == 8902) {
                        sessionStorage.clear()
                        that.$router.push('/login')
                    } else {
                        that.bluesheetsConfirming = false
                        Utils.alert('', res.data.message, 'error')
                    }
                }
            })
            // that.alertMultiData = true
        },
        noOpereate() {
            this.abstainChoose()
        },
        yesOperate() {
            var that = this
            if (that.abstaining)
                return
            that.alertMultiData = false
            that.selectOrganisation = true
            /*that.loadingData = true
            api.getTrackingCategoriesApi({
                callback: (res) => {
                    that.loadingData = false
                    if (!res || !res.data)
                        return
                    if (res.data.code === 0) {
                        that.alertMultiData = false
                        that.selectOrganisation = true
                        console.log(that.selectOrganisation)
                        res.data.data.forEach(item => {
                            let children = []
                            item.Options.forEach(i => {
                                children.push({
                                    id: i.TrackingOptionID,
                                    label: i.Name,
                                    parent: item.TrackingCategoryID
                                })
                            })
                            that.defaultData.push({
                                id: item.TrackingCategoryID,
                                label: item.Name,
                                children: children
                            })
                            that.defaultExpanded.push(item.TrackingCategoryID)
                        })
                        console.log(that.defaultData)
                    } else if (res.data.code == 8902) {
                        sessionStorage.clear()
                        that.$router.push('/login')
                    } else {
                        Utils.alert('', res.data.message, 'error')
                    }
                }
            })*/
            // this.showSuccess = true
        },
        cancelOpereate() {
            var that = this
            if (that.confirmingData)
                return
            that.selectOrganisation = false
            that.abstainChoose()
            that.cancelBluesheetsConfirm()
        },
        clickEvent () {
            this.chosed = this.$refs.tree.getCheckedNodes()
        },
        confirmOperate() {
            // this.showSuccess = true
            var that = this
            const node_selected = this.$refs.tree.getCheckedNodes()
            let format_selected = []
            that.confirmingData = true
            node_selected.forEach(item => {
                if (item.children) {
                    format_selected.push({
                        categoryId: item.id,
                        name: item.label,
                        options: []
                    })
                } else {
                    let hasParent = false
                    format_selected.forEach(i => {
                        if (i.categoryId == item.parent) {
                            hasParent = true
                            i.options.push({
                                optionId: item.id,
                                name: item.label
                            })
                        }
                    })
                    if (!hasParent) {
                        format_selected.push({
                            categoryId: item.parent,
                            name: item.label,
                            options: [{optionId: item.id, name: item.label}]
                        })
                    }
                }
            })
            api.saveTrackingCategoriesApi({
                params: {
                    trackingCategoryPOJOList: format_selected,
                },
                code: that.bluesheetsEnterKey,
                callback: (res) => {
                    that.confirmingData = false
                    if (res.data.code == 0) {
                        this.selectOrganisation = false
                        this.showSuccess = true
                    } else {
                        Utils.alert('', res.data.message ,'error')
                    }
                }
            })
        },
        done() {
            this.showSuccess = false
            this.$emit('done')
        },
        abstainChoose() {
            var that = this
            that.abstaining = true
            that.$emit('closeShow')
            that.$emit('closeShowAsk')
            api.saveTrackingCategoriesApi({
                params: {trackingCategoryPOJOList: []},
                code: that.bluesheetsEnterKey,
                callback: (res) => {
                    that.abstaining = false
                    this.alertMultiData = false
                    if (res.data.code == 0) {
                        that.showSuccess = true
                    } else {
                        Utils.alert('', res.data.message ,'error')
                    }
                }
            })
        },
        autoConfirmOperate() {
            // this.showSuccess = true
            var that = this
            api.saveTrackingCategoriesApi({
                params: {
                    trackingCategoryPOJOList: [],
                },
                code: that.bluesheetsEnterKey,
                callback: (res) => {
                    that.bluesheetsConfirming = false
                    that.$emit('closeShow')
                    that.$emit('closeShowAsk')
                    if (res.data.code == 0) {
                        that.done()
                    } else {
                        Utils.alert('', res.data.message ,'error')
                    }
                }
            })
        },
    },
    watch: {
        show: {
            deep: true,
            handler: function (val) {
                if (val){
                    this.bluesheetsEnterKey = ''
                    this.bluesheetsEnterKeyOpen = true
                }
             }
        },
        showAsk: {
            deep: true,
            handler: function (val) {
                if (val){
                    this.showBindBluesheetsAsk = true
                }
             }
        }
    }
}
</script>

<style lang="scss" src="@/assets/css/dashborad.scss" scoped></style>


// WEBPACK FOOTER //
// src/components/common/bluesheets.vue